import {AUBERGINE} from './aubergine';
import {DARK} from './dark';
import {NIGHT} from './night';
import {RETRO} from './retro';
import {SILVER} from './silver';

export const themes = {
	AUBERGINE: AUBERGINE,
	DARK: DARK,
	NIGHT: NIGHT,
	RETRO: RETRO,
	SILVER: SILVER,
};